export default {
  getUserDefineRow: {
    url: '/feedback/report/page',
    method: 'post',
    desc: 'Feedback分页接口'
  }
}
